module.exports = __webpack_public_path__ + "static/halcotherm-fc87e54680b5d9ae880d266a78a4fec7.jpg";